import MyStepTypes from './mystep.types'

export const setInitialMyStepDetails = () => ({
    type: MyStepTypes.FETCH_MYSTEP_DETAILS.PENDING,
});

export const getReport = () => ({
    type: MyStepTypes.FETCH_REPORT.PENDING,
}); 

